const autocompleteHit = (item) => {
  const { url, title, images } = item
  let image

  if (images?.base) {
    image = images.base
  } else {
    if (images?.medium) {
      image = images.medium
    }
  }

  return `
  <li>
    <a href="${url}" class="feed-autocomplete" target="_blank">
      ${image ? `<img src="${image}" alt="${title}" />` : ``}
      <span class="feed-autocomplete__title">${
        item._highlightResult.title.value
      }
      ${ item._highlightResult.codeArticle ? ` <span class="feed-autocomplete__code_article">(RÉF: ${item._highlightResult.codeArticle.value })</span>` : ``}</span>
    </a>
  </li>
  `
}

export default autocompleteHit
